<script>
import { required, requiredIf, minLength, maxLength } from "vuelidate/lib/validators";
import relation_relative from "../../helpers/list/pilgrimage/relation_relative.json";
import doctrine from "../../helpers/list/pilgrimage/doctrine.json";
import transportation_type from "../../helpers/list/pilgrimage/transportation_type.json";
import city from "../../helpers/list/city.json";
import nationalism from "../../helpers/list/pilgrimage/nationalism.json";

export default {
  components: {},
  props: {},

  data() {
    return {
      relation_relative_id: "",
      doctrine_id: "",
      nationalism_id: "",
      transportation_type_id: "",
      phone1: "",
      phone2: "",
      nationality_number: "",
      board_name: "",
      is_do_pilgrimaged: "",
      has_prev_beneficiary: "",
      prev_beneficiary_name: "",
      prev_beneficiary_year: "",
      is_benefited: "",
      city_id: "",
      district: "",
      region: "",
      mahla: "",
      zqaq: "",
      dar: "",

      //lists
      list_relation_relatives: relation_relative,
      list_doctrines: doctrine,
      list_nationalisms: nationalism,
      list_transportation_types: transportation_type,
      list_city: city,
    };
  },
  validations: {
    board_name: { minLength: minLength(2), maxLength: maxLength(50) },
    phone1: { required, minLength: minLength(11), maxLength: maxLength(11) },
    phone2: { required, minLength: minLength(11), maxLength: maxLength(11) },
    nationality_number: {
      required,
      minLength: minLength(12),
      maxLength: maxLength(12),
    },
    relation_relative_id: {
      required: requiredIf(function () {
        return this.getMartyrCategory();
      }),
    },
    doctrine_id: { required },
    nationalism_id: { required },
    transportation_type_id: { required },
    is_do_pilgrimaged: { required },
    has_prev_beneficiary: { required },
    prev_beneficiary_name: {
      required: requiredIf(function () {
        return this.has_prev_beneficiary == "1";
      }),
      minLength: minLength(2),
      maxLength: maxLength(100),
    },
    prev_beneficiary_year: {
      required: requiredIf(function () {
        return this.has_prev_beneficiary == "1";
      }),
      minLength: minLength(4),
      maxLength: maxLength(4),
    },
    is_benefited: { required },
    city_id: { required },
    district: { required, minLength: minLength(2), maxLength: maxLength(50) },
    region: { required, minLength: minLength(2), maxLength: maxLength(50) },
    mahla: { maxLength: maxLength(10) },
    zqaq: { maxLength: maxLength(10) },
    dar: { maxLength: maxLength(10) },

    form: [
      "relation_relative_id",
      "doctrine_id",
      "nationalism_id",
      "board_name",
      "transportation_type_id",
      "phone1",
      "phone2",
      "nationality_number",
      "is_do_pilgrimaged",
      "has_prev_beneficiary",
      "prev_beneficiary_name",
      "prev_beneficiary_year",
      "is_benefited",
      "city_id",
      "district",
      "region",
      "mahla",
      "zqaq",
      "dar",
    ],
  },
  methods: {
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },
    getMartyrCategory() {
      return this.$parent.$parent.$parent.$refs["sacrificer_info"]["category_id"] == "1";
    },
    getInjuryCategory() {
      return this.$parent.$parent.$parent.$refs["sacrificer_info"]["category_id"] == "2";
    },
    getRelationRelative() {
      return this.getMartyrCategory()
        ? this.list_relation_relatives.slice(1)
        : this.list_relation_relatives;
    },
    getPrevBeneficiary() {
      return this.has_prev_beneficiary == "1";
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <!-- title -->
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">بيانات الحاج</h5></div>

      <div class="col-md-12" v-if="getMartyrCategory()">
        <div class="row">
          <b-form-group
            class="col-md-6 mb-3"
            label=" صلة القرابة : "
            label-for="relation_relative_id"
          >
            <select
              class="form-control"
              id="relation_relative_id"
              v-model="relation_relative_id"
              :class="{ 'is-invalid': $v.relation_relative_id.$error }"
            >
              <option value="">اختر صلة القرابة</option>
              <option
                v-for="relation_relative in getRelationRelative()"
                :value="relation_relative.id"
                :key="relation_relative.id"
              >
                {{ relation_relative.name }}
              </option>
            </select>
            <div v-if="$v.relation_relative_id.$error" class="invalid-feedback">
              <span v-if="!$v.relation_relative_id.required">هذا الحقل الزامي</span>
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-6 mb-3"
            label=" اسم الدائرة الحكومية (مع المديرية او القسم الذ ي يعمل به) في حال كان موظف : "
            label-for="board_name"
          >
            <b-form-input
              id="board_name"
              type="text"
              placeholder="ادخل اسم الدائرة الحكومية لغرض استحصال الاجازة"
              v-model="board_name"
              :class="{ 'is-invalid': $v.board_name.$error }"
            ></b-form-input>
            <div v-if="$v.board_name.$error" class="invalid-feedback">
              <span v-if="!$v.board_name.minLength"
                >يجب أن يتكون اسم الدائرة الحكومية من حرفين على الأقل</span
              >
              <span v-if="!$v.board_name.maxLength"
                >يجب أن يتكون اسم الدائرة الحكومية من 50 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
        </div>
      </div>
    </div>
    <div class="row">
      <b-form-group class="col-md-4 mb-3" label=" المذهب : " label-for="doctrine_id">
        <select
          class="form-control"
          id="doctrine_id"
          v-model="doctrine_id"
          :class="{ 'is-invalid': $v.doctrine_id.$error }"
        >
          <option value="">اختر المذهب</option>
          <option
            v-for="doctrine in list_doctrines"
            :value="doctrine.id"
            :key="doctrine.id"
          >
            {{ doctrine.name }}
          </option>
        </select>
        <div v-if="$v.doctrine_id.$error" class="invalid-feedback">
          <span v-if="!$v.doctrine_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group class="col-md-4 mb-3" label=" القومية : " label-for="nationalism_id">
        <select
          class="form-control"
          id="nationalism_id"
          v-model="nationalism_id"
          :class="{ 'is-invalid': $v.nationalism_id.$error }"
        >
          <option value="">اختر القومية</option>
          <option
            v-for="nationalism in list_nationalisms"
            :value="nationalism.id"
            :key="nationalism.id"
          >
            {{ nationalism.name }}
          </option>
        </select>
        <div v-if="$v.nationalism_id.$error" class="invalid-feedback">
          <span v-if="!$v.nationalism_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group
        class="col-md-4 mb-3"
        label=" طريقة النقل : "
        label-for="transportation_type_id"
      >
        <select
          class="form-control"
          id="transportation_type_id"
          v-model="transportation_type_id"
          :class="{ 'is-invalid': $v.transportation_type_id.$error }"
        >
          <option value="">اختر طريقة النقل</option>
          <option
            v-for="transportation_type in list_transportation_types"
            :value="transportation_type.id"
            :key="transportation_type.id"
          >
            {{ transportation_type.name }}
          </option>
        </select>
        <div v-if="$v.transportation_type_id.$error" class="invalid-feedback">
          <span v-if="!$v.transportation_type_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
    </div>
    <div class="row">
      <b-form-group class="col-md-4 mb-3" label=" رقم هاتف الحاج 1 : " label-for="phone1">
        <b-form-input
          id="phone1"
          type="number"
          placeholder="ادخل رقم الهاتف"
          v-model="phone1"
          :class="{ 'is-invalid': $v.phone1.$error }"
        ></b-form-input>
        <div v-if="$v.phone1.$error" class="invalid-feedback">
          <span v-if="!$v.phone1.required">هذا الحقل الزامي</span>
          <span v-if="!$v.phone1.minLength"
            >يجب أن يتكون رقم الهاتف من 11 رقم على الأقل</span
          >
          <span v-if="!$v.phone1.maxLength"
            >يجب أن يتكون رقم الهاتف من 11 رقم على الاكثر</span
          >
        </div>
      </b-form-group>
      <b-form-group class="col-md-4 mb-3" label=" رقم هاتف الحاج 2 : " label-for="phone2">
        <b-form-input
          id="phone2"
          type="number"
          placeholder="ادخل رقم الهاتف"
          v-model="phone2"
          :class="{ 'is-invalid': $v.phone2.$error }"
        ></b-form-input>
        <div v-if="$v.phone2.$error" class="invalid-feedback">
          <span v-if="!$v.phone2.minLength"
            >يجب أن يتكون رقم الهاتف من 11 رقم على الأقل</span
          >
          <span v-if="!$v.phone2.maxLength"
            >يجب أن يتكون رقم الهاتف من 11 رقم على الاكثر</span
          >
        </div>
      </b-form-group>
      <b-form-group
        class="col-md-4 mb-3"
        label="رقم البطاقة الوطنية :"
        label-for="nationality_number"
      >
        <b-form-input
          id="nationality_number"
          type="number"
          placeholder="ادخل رقم البطاقة الوطنية"
          v-model="nationality_number"
          :class="{ 'is-invalid': $v.nationality_number.$error }"
        ></b-form-input>
        <div v-if="$v.nationality_number.$error" class="invalid-feedback">
          <span v-if="!$v.nationality_number.required">هذا الحقل الزامي</span>
          <span v-if="!$v.nationality_number.minLength"
            >يجب أن يتكون رقم البطاقة الوطنية من 12 رقم على الأقل</span
          >
          <span v-if="!$v.nationality_number.maxLength"
            >يجب أن يتكون رقم البطاقة الوطنية من 12 رقم على الاكثر</span
          >
        </div>
      </b-form-group>
    </div>
    <div class="row">
      <b-form-group
        class="col-md-6 mb-3"
        label=" هل ذهبت الى الحج سابقا : "
        label-for="is_do_pilgrimaged"
      >
        <select
          class="form-control"
          id="is_do_pilgrimaged"
          v-model="is_do_pilgrimaged"
          :class="{ 'is-invalid': $v.is_do_pilgrimaged.$error }"
        >
          <option value="">اختر الاجابة</option>
          <option value="1">نعم</option>
          <option value="0">لا</option>
        </select>
        <div v-if="$v.is_do_pilgrimaged.$error" class="invalid-feedback">
          <span v-if="!$v.is_do_pilgrimaged.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group
        class="col-md-6 mb-3"
        label=" هل ذهبت الى الحج عن طريق هيأة                                                                                                                                                                                                                      الحشد سابقا : "
        label-for="is_benefited"
      >
        <select
          class="form-control"
          id="is_benefited"
          v-model="is_benefited"
          :class="{ 'is-invalid': $v.is_benefited.$error }"
        >
          <option value="">اختر الاجابة</option>
          <option value="1">نعم</option>
          <option value="0">لا</option>
        </select>
        <div v-if="$v.is_benefited.$error" class="invalid-feedback">
          <span v-if="!$v.is_benefited.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
    </div>
    <div class="row">
      <b-form-group
        class="col-md-12 mb-3"
        label=" هل يوجد احد من ذوي الشهيد مستفيد من خدمة الحج سابقا : "
        label-for="has_prev_beneficiary"
      >
        <select
          class="form-control"
          id="has_prev_beneficiary"
          v-model="has_prev_beneficiary"
          :class="{ 'is-invalid': $v.has_prev_beneficiary.$error }"
        >
          <option value="">اختر الاجابة</option>
          <option value="1">نعم</option>
          <option value="0">لا</option>
        </select>
        <div v-if="$v.has_prev_beneficiary.$error" class="invalid-feedback">
          <span v-if="!$v.has_prev_beneficiary.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
    </div>
    <div class="row" v-if="getPrevBeneficiary()">
      <b-form-group
        class="col-md-6 mb-3"
        label="اسم المستفيد من خدمة الحج سابقا : "
        label-for="prev_beneficiary_name"
      >
        <b-form-input
          id="prev_beneficiary_name"
          type="text"
          placeholder="ادخل اسم المستفيد من خدمة الحج سابقا"
          v-model="prev_beneficiary_name"
          :class="{ 'is-invalid': $v.prev_beneficiary_name.$error }"
        ></b-form-input>
        <div v-if="$v.prev_beneficiary_name.$error" class="invalid-feedback">
          <span v-if="!$v.prev_beneficiary_name.required">هذا الحقل الزامي</span>
          <span v-if="!$v.prev_beneficiary_name.minLength"
            >يجب أن يتكون اسم المستفيد من حرفين على الأقل</span
          >
          <span v-if="!$v.prev_beneficiary_name.maxLength"
            >يجب أن يتكون اسم المستفيد من 100 حرف على الاكثر</span
          >
        </div>
      </b-form-group>
      <b-form-group
        class="col-md-6 mb-3"
        label="السنة التي ذهب بها المستفيد الى الحج سابقا :"
        label-for="prev_beneficiary_year"
      >
        <b-form-input
          id="prev_beneficiary_year"
          type="number"
          placeholder="ادخل السنة التي ذهب بها المستفيد الى الحج سابقا"
          v-model="prev_beneficiary_year"
          :class="{ 'is-invalid': $v.prev_beneficiary_year.$error }"
        ></b-form-input>
        <div v-if="$v.prev_beneficiary_year.$error" class="invalid-feedback">
          <span v-if="!$v.prev_beneficiary_year.required">هذا الحقل الزامي</span>
          <span v-if="!$v.prev_beneficiary_year.minLength"
            >يجب أن تكون السنة من 4 ارقام على الأقل</span
          >
          <span v-if="!$v.prev_beneficiary_year.maxLength"
            >يجب أن تكون السنة من 4 ارقام على الاكثر</span
          >
        </div>
      </b-form-group>
    </div>
    <div class="row">
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">بيانات السكن</h5></div>

      <b-form-group class="col-md-4 mb-3" label=" المحافظة : " label-for="city_id">
        <select
          class="form-control"
          id="city_id"
          v-model="city_id"
          :class="{ 'is-invalid': $v.city_id.$error }"
        >
          <option value="">اختر المحافظة</option>
          <option v-for="city in list_city" :value="city.id" :key="city.id">
            {{ city.name }}
          </option>
        </select>
        <div v-if="$v.city_id.$error" class="invalid-feedback">
          <span v-if="!$v.city_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group class="col-md-4 mb-3" label=" القضاء : " label-for="district">
        <b-form-input
          id="district"
          type="text"
          placeholder="ادخل القضاء "
          v-model="district"
          :class="{ 'is-invalid': $v.district.$error }"
        ></b-form-input>
        <div v-if="$v.district.$error" class="invalid-feedback">
          <span v-if="!$v.district.required">هذا الحقل الزامي</span>
          <span v-if="!$v.district.minLength"
            >يجب أن يتكون القضاء من حرفين على الأقل</span
          >
          <span v-if="!$v.district.maxLength"
            >يجب أن يتكون القضاء من 50 حرف على الاكثر</span
          >
        </div>
      </b-form-group>
      <b-form-group class="col-md-4 mb-3" label=" المنطقة : " label-for="region">
        <b-form-input
          id="region"
          type="text"
          placeholder="ادخل المنطقة"
          v-model="region"
          :class="{ 'is-invalid': $v.region.$error }"
        ></b-form-input>
        <div v-if="$v.region.$error" class="invalid-feedback">
          <span v-if="!$v.region.required">هذا الحقل الزامي</span>
          <span v-if="!$v.region.minLength">يجب أن تتكون المنطقة من حرفين على الأقل</span>
          <span v-if="!$v.region.maxLength"
            >يجب أن تتكون المنطقة من 50 حرف على الاكثر</span
          >
        </div>
      </b-form-group>
      <b-form-group class="col-md-4 mb-3" label=" محلة : " label-for="mahla">
        <b-form-input
          id="mahla"
          type="text"
          placeholder="ادخل المحلة "
          v-model="mahla"
          :class="{ 'is-invalid': $v.mahla.$error }"
        ></b-form-input>
        <div v-if="$v.mahla.$error" class="invalid-feedback">
          <span v-if="!$v.mahla.maxLength">يجب أن تتكون المحلة من 10 حرف على الاكثر</span>
        </div>
      </b-form-group>
      <b-form-group class="col-md-4 mb-3" label=" زقاق : " label-for="zqaq">
        <b-form-input
          id="zqaq"
          type="text"
          placeholder="ادخل الزقاق"
          v-model="zqaq"
          :class="{ 'is-invalid': $v.zqaq.$error }"
        ></b-form-input>
        <div v-if="$v.zqaq.$error" class="invalid-feedback">
          <span v-if="!$v.zqaq.maxLength">يجب أن يتكون الزقاق من 10 حرف على الاكثر</span>
        </div>
      </b-form-group>
      <b-form-group class="col-md-4 mb-3" label=" دار : " label-for="dar">
        <b-form-input
          id="dar"
          type="text"
          placeholder="ادخل الدار"
          v-model="dar"
          :class="{ 'is-invalid': $v.dar.$error }"
        ></b-form-input>
        <div v-if="$v.dar.$error" class="invalid-feedback">
          <span v-if="!$v.dar.maxLength">يجب أن يتكون الدار من 10 حرف على الاكثر</span>
        </div>
      </b-form-group>
    </div>
  </div>
  <!-- end page title -->
</template>
